import type { Event_Entry } from '@/lib/graphql-sdk';
import type { LanguageCategory } from '@/types/custom';
import { getShowCategories, getShowLanguages } from './show';
export function filterEvents(events: Event_Entry[], activeFilters: string[]): Event_Entry[] {
    if (!activeFilters.length) {
        return events;
    }

    return events.filter((event: Event_Entry) => {
        // If no filters are active, show all events
        if (!activeFilters || activeFilters.length === 0) {
            return true;
        }

        return activeFilters.every((filter) => {
            switch (filter) {
                case 'english':
                    return getShowLanguages(event)
                        ?.map((language: LanguageCategory) => language.slug)
                        .includes('english');
                case 'best-of-stand-up':
                    return (
                        event.slug?.includes('best-of-stand-up') ||
                        event.eventTitle?.includes('Best of Stand-Up')
                    );
                case 'open-mic':
                    return event.slug?.includes('open-mic');
                case 'double-act':
                    return getShowCategories(event)
                        .map((category) => category.slug)
                        .includes('dubbel-show');
                case 'solo-show':
                    return getShowCategories(event)
                        .map((category) => category.slug)
                        .includes('solo-show');
                default:
                    return true;
            }
        });
    });
}
